module.exports = __webpack_public_path__ + "661d2b22fec2ccb5841d9cd0f9b668ff.pdf";